import { render, staticRenderFns } from "./card.vue?vue&type=template&id=31a4bb61&scoped=true&"
import script from "./card.vue?vue&type=script&lang=js&"
export * from "./card.vue?vue&type=script&lang=js&"
import style0 from "./card.vue?vue&type=style&index=0&id=31a4bb61&scoped=true&lang=scss&"
import style1 from "./card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4bb61",
  null
  
)

export default component.exports